import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {auth} from './firebase'

import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';

import './assets/style.css'
// import './assets/style-auth.css';

Vue.use(ElementUI)

Vue.config.productionTip = false


auth.onAuthStateChanged((user) => {
  const user_before = store.state.user

  store.commit('setUser', user)

  if (user_before != null && user == null) {
    router.go({name: 'login'})
    return
  }

  router.beforeEach(async (to, from, next) => {
    const requiresAuth = to.matched.some( record => record.meta.requiresAuth)
    const requiresAdmin = to.matched.some( record => record.meta.requiresAdmin)
    const doEvaluasi = to.matched.some( record => record.meta.doEvaluasi)

    const lagiNgerjainHalaman = store.state.lagiNgerjainHalaman

    if (requiresAuth && user == null){
      localStorage.clear()
      next({name: 'login'});
    } else if (requiresAdmin && user.displayName != 'admin') {
      next({name: 'forbidden'})
    } else if (!requiresAuth && user != null) {
      next({name: 'kata-pengantar'})
    } else if (!doEvaluasi && lagiNgerjainHalaman != null && lagiNgerjainHalaman != 'null') {
      next({name: 'evaluasi-user', params: {halaman: store.state.lagiNgerjainHalaman}})
    } else if (doEvaluasi && (lagiNgerjainHalaman == null || lagiNgerjainHalaman == 'null')) {
      next({name: 'kata-pengantar'})
    } else {
      next()
    }
  })

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
  
})
